import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import solar1 from '../img/Solar/solar1.png'
import solar2 from '../img/Solar/solar2.jpg'

function SolarProductSystem() {
  useEffect(() => {
    AOS.init({ duration: 800 });
  }, []);

  return (
    <section className="py-5 mt-5 bg-light" id="solar-solutions">
      <div className="container">
        <div className="text-center mb-5" data-aos="fade-up">
          <h2 className="fw-bold text-dark">☀️ Solar Solutions (Off-Grid & On-Grid)</h2>
          <p className="text-muted">
            Provides clean, renewable energy for homes, industries, offices, and institutions—either independently (off-grid) or connected to the national grid (on-grid).
          </p>
        </div>

        <div className="row mb-5" data-aos="zoom-in">
          <div className="col-md-6 mb-3">
            <img
              src={solar1}
              alt="Busbar Trunking System"
              className="img-fluid rounded shadow"
              style={{ maxHeight: '325px', objectFit: 'cover', width: '100%' }}
            />
          </div>
          <div className="col-md-6 mb-3">
            <img
              src={solar2}
              alt="Busbar System Setup"
              className="img-fluid rounded shadow"
              style={{ maxHeight: '295px', objectFit: 'cover', width: '100%' }}
            />
          </div>
        </div>

        {/* Ratings */}
        <div className="mb-4" data-aos="fade-up">
          <h4 className="text-primary mb-3">📏 Ratings</h4>
          <ul className="text-muted">
            <li><strong>System Capacity:</strong> 1 kW to 500 kW and above</li>
            <li><strong>Panel Efficiency:</strong> 18%–22% (mono/polycrystalline)</li>
            <li><strong>Voltage:</strong> 12V / 24V / 48V DC (Off-grid), 230V/400V AC (On-grid)</li>
            <li><strong>Inverter Capacity:</strong> 1 kW to 100 kW+</li>
            <li><strong>Battery Backup (Off-grid):</strong> 100Ah – 2000Ah (Li-ion/Lead-acid)</li>
          </ul>
        </div>

        {/* IEC Standards */}
        <div className="mb-4" data-aos="fade-up">
          <h4 className="text-info mb-3">📘 IEC Standards</h4>
          <ul className="text-muted">
            <li><strong>IEC 61215</strong> – Crystalline silicon PV modules</li>
            <li><strong>IEC 62109</strong> – Inverters</li>
            <li><strong>IEC 62509 / 62093</strong> – Charge controllers & balance of system</li>
          </ul>
        </div>

        {/* Key Features */}
        <div className="mb-5" data-aos="fade-up">
          <h4 className="text-success mb-3">✨ Key Features</h4>
          <ul className="text-muted">
            <li>Reliable power supply with clean energy</li>
            <li>Net metering support (for on-grid systems)</li>
            <li>Long-life solar panels with high efficiency</li>
            <li>Lithium/Lead-acid battery storage (off-grid)</li>
            <li>Smart MPPT/Hybrid inverters</li>
            <li>Scalable design for homes to industrial use</li>
            <li>Reduces electricity bills and carbon footprint</li>
          </ul>
        </div>
      </div>
    </section>
  );
}

export default SolarProductSystem;
